export const getPasswordSecurityVerifications = (password) => {
  const verifications = {};

  if (password.length >= 8) verifications.hasEnoughLength = true;

  if (/\d/.test(password)) verifications.hasNumber = true;

  if (/[A-Z]/.test(password)) verifications.hasUppercase = true;

  //eslint-disable-next-line
  const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

  if (format.test(password)) verifications.hasSpecialCharacters = true;

  return verifications;
};
